<div id="transaction-details-section">
  <span id="subtitle">{{ pageHeader }}</span>
  <a *ngIf="(createRequestStep$ | async) === 'review'  && !isInrFromTable" class="no-print" id="edit-link" (click)="onEditClicked()">Edit</a>
  <mm-label-group id="checkDetails_transactionType" [title]="labels.transactionType" [data]="transactionTypeLabel"
    data-testid="checkDetails_transactionType">
  </mm-label-group>

  <!-- Use standing auth -->
  <div class="row" data-testid="checkDetails_standingAuthRowGroup"
    *ngIf="useStandingAuth && !isStandingAuthViewPage && !isPendingSloaSetup && !(isTransactionViewPage && isRecurring)">
    <div class="column">
      <mm-label-group id="checkDetails_standingAuth" data-testid="checkDetails_standingAuth"
        [title]="labels.useStandingAuth" [data]="useStandingAuth | titlecase">
      </mm-label-group>
    </div>
    <div class="column" *ngIf="useStandingAuth === 'yes'">
      <mm-label-group id="itDetails_standingAuthDetails" data-testid="checkDetails_standingAuthDetails"
        [title]="isBsloaTransaction? labels.bundledStandingAuthDetails : labels.standingAuthDetails" [multilineData]="standingAuthDetailsLines"></mm-label-group>
    </div>
  </div>

  <!-- Frequency -->
  <div class="row" id="checkDetails_frequencyRow">
    <div class="column">
      <mm-label-group id="checkDetails_frequency" *ngIf="frequency" data-testid="checkDetails_frequency"
        [title]="labels.frequency" [data]="frequency">
      </mm-label-group>
    </div>
    <div class="column" *ngIf="isRecurring">
      <mm-label-group id="checkDetails_frequencyDescription" data-testid="checkDetails_frequencyDescription"
        [title]="labels.frequencyDescription" [data]="frequencyDescription">
      </mm-label-group>
    </div>
    <div class="column">
      <mm-label-group *ngIf="isOneTimeTotalDist && closeAccount === 'Yes'" id="check_closeAccount" data-testid="check_closeAccount" 
        [title]="labels.closeAccount" 
        [data]="closeAccount"
        class="close-account-column">
      </mm-label-group>
    </div>
    <div class="column check_reportsRequestedSection">
      <mm-label-group *ngIf="isOneTimeTotalDist && closeAccount === 'Yes'" id="check_reportsRequested" data-testid="check_reportsRequested" 
        [title]="labels.reportsRequested" 
        [multilineData]="reportsRequested"
        class="reports-requested-column">
      </mm-label-group>
      <mm-tooltip *ngIf="isOneTimeTotalDist && closeAccount === 'Yes'" [position]="'right'" [containsLink]="false" id="reports-requested-tooltip" data-testid="reports-requested-tooltip">
        <tooltip-content>
          <div>{{reportsRequestedTooltip}}</div>
        </tooltip-content>
        <tooltip-trigger-element>
          <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
        </tooltip-trigger-element>
      </mm-tooltip>
    </div>
  </div>

  <!-- Payee -->
  <div class="row" id="checkDetails_payeeRow" *ngIf="!isIncoming">
    <div class="column">
      <mm-label-group id="checkDetails_payee" data-testid="checkDetails_payee" [title]="labels.payee" [data]="payee">
      </mm-label-group>
    </div>
    <div class="column">
      <mm-label-group id="checkDetails_payeeName" data-testid="checkDetails_payeeName" [title]="labels.payeeName"
        [multilineData]="payeeName">
      </mm-label-group>
    </div>
  </div>

  <!-- Delivery address -->
  <div class="row" *ngIf="!isIncoming">
    <mm-label-group id="checkDetails_deliveryAddress" data-testid="checkDetails_deliveryAddress"
      [title]="labels.deliveryAddress" [multilineData]="deliveryAddress">
    </mm-label-group>
  </div>

  <!-- Process date -->
  <div class="row" data-testid="checkDetails_processDateRowGroup" *ngIf="!isStandingAuthViewPage">
    <div class="column" *ngIf="!isPendingSloaSetup">
      <mm-label-group id="checkDetails_processDate" class="loa loaCreateSloaDetails"
        data-loafieldname="{{pdfLabelsSubmitDetails.checkProcessDate}}" data-testid="checkDetails_processDate"
        [title]="labels.processDate" [data]="processDate | formattedDate">
      </mm-label-group>
    </div>
    <div class="column">
      <mm-label-group *ngIf="isRecurring && hasSecondProcessDate" id="checkDetails_secondProcessDate"
        class="loa loaSubmitDetails" data-loafieldname="{{pdfLabelsSubmitDetails.secondProcessDate}}"
        data-testid="checkDetails_secondProcessDate" [title]="labels.secondProcessDate"
        [data]="secondProcessDate | formattedDate">
      </mm-label-group>
      <mm-label-group *ngIf="isIncoming && asOfDate" id="checkDetails_asOfDate" data-testid="checkDetails_asOfDate"
        [title]="labels.asOfDate" [data]="asOfDate | formattedDate">
      </mm-label-group>
    </div>
    <div class="column" *ngIf="isRecurring && hasEndDate">
      <mm-label-group id="checkDetails_endDate" class="loa loaSubmitDetails"
        data-loafieldname="{{pdfLabelsSubmitDetails.endDate}}" data-testid="checkDetails_endDate"
        [title]="labels.endDate" [data]="endDate | formattedDate">
      </mm-label-group>
    </div>

  </div>

  <!-- Next process date -->
  <div *ngIf="nextProcessDate" class="row" id="checkDetails_nextProcessDate">
    <mm-label-group data-testid="checkDetails_nextProcessDate" id="checkDetails_nextProcessDate"
      [title]="labels.nextProcessDate" [data]="nextProcessDate | formattedDate">
    </mm-label-group>
  </div>

  <!-- Process date copy -->
  <div class="row" data-testid="checkDetails_nextBizDayCopy" *ngIf="!isStandingAuthViewPage && !isTransactionViewPage">
    <span id="process-date-copy">{{processDateCopy}}</span>
  </div>

  <!-- Delivery method and check number-->
  <div class="row" >
    <div class="column" *ngIf="!isRecurring && deliveryMethod && !isPendingSloaSetup">
      <mm-label-group id="checkDetails_deliveryMethod" data-testid="checkDetails_deliveryMethod"
        [title]="labels.deliveryMethod" [data]="parseDeliveryMethod(deliveryMethod)">
      </mm-label-group>
    </div>
    <div class="column" *ngIf="hasCheckNumberForCompletedTransaction">
      <mm-label-group id="checkDetails_checkNumber" data-testid="checkDetails_checkNumber" [title]="labels.checkNumber"
        [data]="checkNumber">
      </mm-label-group>
    </div>
  </div>

  <!-- Check amount -->
  <div class="row" id="checkDetails_amountRow" data-testid="checkDetails_amountRowGroup"
    *ngIf="!isStandingAuthViewPage">
    <div class="column" *ngIf="!isPendingSloaSetup && !isIncoming">
      <mm-label-group id="checkDetails_amount" [ngClass]="{'loa': true, 'loaCreateSloaDetails': !iraAccount}"
        data-loafieldname="{{pdfLabelsSubmitDetails.checkAmount}}" data-testid="checkDetails_amount"
        [title]="labels.amount" [data]="amount">
      </mm-label-group>
    </div>
    <div class="column" *ngIf="isIncoming">
      <mm-label-group id="checkDetails_depositAmount" data-testid="checkDetails_depositAmount"
        [title]="labels.depositAmount" [data]="depositAmount">
      </mm-label-group>
    </div>
    <div class="column" *ngIf="payIncome">
      <mm-label-group id="checkDetails_payIncome" data-testid="checkDetails_payIncome" [title]="labels.payIncome"
        [data]="payIncome">
      </mm-label-group>
    </div>
    <div class="column" *ngIf="iraAccount && !isPendingSloaSetup && !isIncoming">
      <mm-label-group id="checkDetails_grossNet" data-testid="checkDetails_grossNet" [title]="labels.grossNet"
        [data]="amountType | titlecase">
      </mm-label-group>
    </div>
  </div>

  <!-- PTRS FIELDS -->
  <div id="checkDetails_ptrsFields" *ngIf="isPtrs">
    <!-- INCOME & PRINCIPAL PERCENTAGES -->
    <div *ngIf="trustIncomePercent || trustPrincipalPercent" class="row" id="checkDetails_trustIncomePrincipalPercentRow">
      <div class="column" *ngIf="trustIncomePercent">
        <mm-label-group id="checkDetails_trustIncomePercent" data-testid="checkDetails_trustIncomePercent"
          [title]="labels.trustIncomePercent" [data]="trustIncomePercent">
        </mm-label-group>
      </div>
      <div class="column" *ngIf="trustPrincipalPercent">
        <mm-label-group id="checkDetails_trustPrincipalPercent" data-testid="checkDetails_trustPrincipalPercent"
          [title]="labels.trustPrincipalPercent" [data]="trustPrincipalPercent">
        </mm-label-group>
      </div>
    </div>

    <!-- TRUST TAX CATEGORY -->
    <div class="row" id="checkDetails_trustTaxCategoryRow" *ngIf="trustTaxCategory">
      <div class="column">
        <mm-label-group id="checkDetails_trustTaxCategory" data-testid="checkDetails_trustTaxCategory"
          [title]="labels.trustTaxCategory" [data]="trustTaxCategory | sentenceCase">
        </mm-label-group>
      </div>
    </div>

    <!-- TRUST TAX CODE -->
    <div class="row" id="checkDetails_trustTaxCodeRow" *ngIf="trustTaxCode">
      <div class="column">
        <mm-label-group id="checkDetails_trustTaxCode" data-testid="checkDetails_trustTaxCode"
          [title]="labels.trustTaxCode" [data]="trustTaxCode | sentenceCase">
        </mm-label-group>
      </div>
    </div>

    <!-- PAID FOR -->
    <div class="row" id="checkDetails_paidForRow" *ngIf="trustPaidFor">
      <div class="column">
        <mm-label-group id="checkDetails_trustPaidFor" data-testid="checkDetails_trustPaidFor"
          [title]="labels.trustPaidFor" [data]="trustPaidFor | name">
        </mm-label-group>
      </div>
    </div>
  </div>

  <!-- Comment -->
  <div class="row" id="checkDetails_CommentRow" *ngIf="isPtrs && isNotEmptyOrNull(trustComment)">
    <div class="column">
      <mm-label-group id="checkDetails_trustComment" data-testid="checkDetails_trustComment"
        [title]="labels.trustComment" [data]="trustComment | name">
      </mm-label-group>
    </div>
  </div>

  <!-- Check memo -->
  <div class="row" *ngIf="memo">
    <mm-label-group id="checkDetails_memo" data-testid="checkDetails_memo" [title]="labels.memo" [data]="memo">
    </mm-label-group>
  </div>

  <!-- TWE FIELDS -->
  <div *ngIf="iraAccount && !isIncoming">
    <div class="row" id="checkDetails_federalTaxRow">
      <div class="column">
        <mm-label-group id="checkDetails_federalTax" data-testid="checkDetails_federalTax" [title]="labels.federalTax"
          [data]="fedTaxPercent"></mm-label-group>
      </div>
      <div class="column">
        <mm-label-group *ngIf="!isStandingAuthViewPage && !isPendingSloaSetup && !isOneTimeTotalDist"
          class="loa loaCreateSloaDetails" data-loafieldname="{{pdfLabelsSubmitDetails.fedTaxAmount}}"
          id="checkDetails_federalTaxAmount" data-testid="checkDetails_federalTaxAmount"
          [title]="labels.federalTaxAmount" [data]="fedTaxAmount">
        </mm-label-group>
      </div>
    </div>
    <div class="row" id="checkDetails_stateTaxRow">
      <div class="column">
        <mm-label-group id="checkDetails_stateTax" data-testid="checkDetails_stateTax"
                        [title]="stateTaxLabel" [data]="stateTaxPercent"></mm-label-group>
      </div>
      <div class="column">
        <mm-label-group *ngIf="!isStandingAuthViewPage && !isPendingSloaSetup && !isOneTimeTotalDist"
          class="loa loaCreateSloaDetails" data-loafieldname="{{pdfLabelsSubmitDetails.stateTaxAmount}}"
          id="checkDetails_stateTaxAmount" data-testid="checkDetails_stateTaxAmount" [title]="labels.stateTaxAmount"
          [data]="stateTaxAmount">
        </mm-label-group>
      </div>
    </div>
    <div class="row" id="checkDetails_netCashRow" data-testid="checkDetails_netCashTotal"
      *ngIf="!isStandingAuthViewPage && !isPendingSloaSetup">
      <div class="column">
      </div>
      <div class="column">
        <mm-label-group class="loa loaCreateSloaDetails"
          data-loafieldname="{{pdfLabelsSubmitDetails.checkAmount}}" id="checkDetails_netCashAmountTotal"
          data-testid="checkDetails_netCashAmountTotal" [title]="isOneTimeTotalDist ? labels.totalWithdrawalAmountCheck : labels.netCashAmount"
          [data]="totalWithdrawalAmount"></mm-label-group>
      </div>
    </div>
    <div class="row" *ngIf="!!distributionReason">
      <div class="column">
        <mm-label-group class="loa loaCreateSloaDetails"
          data-loafieldname="{{pdfLabelsSubmitDetails.distributionReason}}" id="checkDetails_distributionReason"
          data-testid="checkDetails_distributionReason" [title]="labels.distributionReason"
          [data]="distributionReason"></mm-label-group>
      </div>
    </div>
    <div class="label-group" data-testid="checkDetails_taxParagraphOne"
      *ngIf="(createRequestStep$ | async) === 'review'">
      <span id="tax-copy-paragraph-one">{{taxCopyParagraphOne}}</span>
    </div>
    <div class="label-group" data-testid="checkDetails_taxParagraphTwo"
      *ngIf="(createRequestStep$ | async) === 'review'">
      <span id="tax-copy-paragraph-two">{{taxCopyParagraphTwo}}</span>
    </div>
  </div>

  <!-- IRA contribution type -->
  <div class="row" *ngIf="isIncoming && iraContributionType">
    <mm-label-group id="checkDetails_iraContributionType" data-testid="checkDetails_iraContributionType"
      [title]="labels.iraContributionType" [data]="iraContributionType">
    </mm-label-group>
  </div>

  <!-- Fund hold dates -->
  <div class="row" *ngIf="isIncoming && fundsHeld">
    <mm-label-group id="checkDetails_fundsHeld" data-testid="checkDetails_fundsHeld" [title]="labels.fundHoldDates"
      [multilineData]="fundsHeld">
    </mm-label-group>
  </div>

  <!-- Check reason -->
  <div class="row" *ngIf="checkReason && selectReason(checkReason)">
    <mm-label-group id="checkDetails_checkReason" class="loa loaCreateSloaDetails"
      data-testid="checkDetails_checkReason" data-loafieldname="{{pdfLabelsSubmitDetails.withdrawalReason}}" [title]="labels.checkReason"
      [data]="selectReason(checkReason) | sentenceCase">
    </mm-label-group>
  </div>

  <div class="row" *ngIf="memoLine2 && memoLine2.length > 0 && checkReason.length === 0">
    <mm-label-group id="checkDetails_checkReason" class="loa loaCreateSloaDetails"
      data-testid="checkDetails_checkReason" data-loafieldname="{{pdfLabelsSubmitDetails.withdrawalReason}}" [title]="labels.checkReason"
      [data]="memoLine2 | sentenceCase">
    </mm-label-group>
  </div>

  <!-- PTRS disclaimer -->
  <mm-banners *ngIf="isPtrs && (isStandingAuthViewPage || isTransactionViewPage)"
    [bannerText]="[viewPagePtrsInfoBannerPrimaryText]" [boldText]="viewPagePtrsInfoBannerBoldText"
    [type]="'information'" [showCloseIcon]="false" id="checkDetails_ptrsDisclaimer"
    data-testid="checkDetails_ptrsDisclaimer"></mm-banners>
